// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"fb29a27f","418":"769cc463","461":"94405921","686":"8b612160","691":"74d1c80d","744":"bb4b4409","787":"bf3fbcdd","845":"83d391f4","895":"06237709"}[chunkId] + ".chunk.js";
};